import { render } from "./AppointmentConfirmation.vue?vue&type=template&id=45c0d88a&ts=true"
import script from "./AppointmentConfirmation.vue?vue&type=script&lang=ts"
export * from "./AppointmentConfirmation.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__